import React from 'react';
import AlertIcon from '../../../src/img.svg';
import { destroy } from '../../services/apiController';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

const DeleteModal = (props) => {
  const { title, description, open, onClose, url, callback } = props;

  const handleRemove = (e) => {
    e.preventDefault();
    destroy(url)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response?.data?.message || 'Record has been deleted successfully');
          onClose();
          callback();
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.data?.message || error?.response?.data?.message || error?.message || 'internal error');
      });
  };

  return (
    <Modal size="sm" show={open} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header className="bg-danger text-light py-2">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-start">
          <img src={AlertIcon} alt="alert" />
          <p className="ps-3 mb-0">{description}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="btn-wrapper">
          <button onClick={onClose} className="btn app-btn-default btn-sm">
            Cancel
          </button>
          <button onClick={handleRemove} className="btn app-btn-danger btn-sm">
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
